import React from 'react';
import { Users, Lock, ArrowRight } from 'lucide-react';
import { useDashboardStore } from '../../store/dashboardStore';
import { pushRoute } from '../../utils/routing';
import { Navbar } from '../Header/Navbar';

export const Landing: React.FC = () => {
  const { familyTrees } = useDashboardStore();
  const firstTree = familyTrees[0];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />

      {/* Hero */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-2xl w-full text-center">
          <div className="w-24 h-24 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center overflow-hidden">
            <img src="/logo.svg" alt="Munshis logo" className="h-14 w-auto" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {firstTree?.name ?? 'Our Family Tree'}
          </h2>
          {firstTree?.description && (
            <p className="text-gray-600 mb-8 max-w-xl mx-auto">
              {firstTree.description}
            </p>
          )}
          {firstTree && (
            <div className="flex items-center justify-center space-x-2 text-gray-500 mb-10">
              <Users className="w-4 h-4" />
              <span className="text-sm">
                {firstTree.memberCount} members • {firstTree.generationCount} generations
              </span>
            </div>
          )}

          {firstTree && (
            <button
              onClick={() => pushRoute(`/family-tree/${firstTree.id}`)}
              className="inline-flex items-center space-x-2 px-8 py-4 bg-green-600 text-white text-lg font-semibold rounded-xl hover:bg-green-700 transition-colors shadow-lg"
            >
              <span>View Family Tree</span>
              <ArrowRight className="w-5 h-5" />
            </button>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-white px-6 py-4 text-center">
        <p className="text-sm text-gray-500">
          © {new Date().getFullYear()} Munshis. All rights reserved.
        </p>
      </footer>
    </div>
  );
};
